{
  "title": "Arms of Hadar",
  "source": "Player's Handbook",
  "levelAndSchool": "1st-level conjuration",
  "level": 1,
  "castingTime": "1 action",
  "range": "Self (10-foot radius)",
  "components": "V, S",
  "duration": "Instantaneous",
  "description": [
    "You invoke the power of Hadar, the Dark Hunger. Tendrils of dark energy erupt from you and batter all creatures within 10 feet of you. Each creature in that area must make a Strength saving throw. On a failed save, a target takes 2d6 necrotic damage and can’t take reactions until its next turn. On a successful save, the creature takes half damage, but suffers no other effect.",
    "At Higher Levels. When you cast this spell using a spell slot of 2nd level or higher, the damage increases by 1d6 for each slot level above 1st."
  ],
  "spellLists": ["warlock"]
}
